"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreRoutes = void 0;
const users_1 = require("./users");
const user_preferences_1 = require("./user_preferences");
const payments_1 = require("./payments");
const payment_invitations_1 = require("./payment_invitations");
const currencies_1 = require("./currencies");
const admin_1 = require("./admin");
const deposits_1 = require("./deposits");
const linked_accounts_1 = require("./linked_accounts");
const requests_1 = require("./requests");
const snapshot_1 = require("./snapshot");
const withdrawals_1 = require("./withdrawals");
const device_tokens_1 = require("./device_tokens");
const services_1 = require("./services");
const referrals_1 = require("./referrals");
const messages_1 = require("./messages");
const public_1 = require("./public");
const kyc_1 = require("./kyc");
const airtime_1 = require("./airtime");
const paystack_1 = require("./paystack");
const billers_1 = require("./billers");
const limits_1 = require("./limits");
const orders_1 = require("./orders");
const asset_trades_1 = require("./asset_trades");
const ipqs_fingerprint_1 = require("./ipqs_fingerprint");
const data_bundles_1 = require("./data_bundles");
const stocks_1 = require("./stocks");
const plaid_1 = require("./plaid");
const crypto_1 = require("./crypto");
const cards_1 = require("./cards");
const user_account_authorizations_1 = require("./user_account_authorizations");
class CoreRoutes {
    constructor() {
        this.users = new users_1.UserRoutes();
        this.userPreferences = new user_preferences_1.UserPreferenceRoutes();
        this.currencies = new currencies_1.CurrencyRoutes();
        this.admin = new admin_1.AdminRoutes();
        this.deposits = new deposits_1.DepositRoutes();
        this.linkedAccounts = new linked_accounts_1.LinkedAccountRoutes();
        this.payments = new payments_1.PaymentRoutes();
        this.paymentInvitations = new payment_invitations_1.PaymentInvitationRoutes();
        this.requests = new requests_1.RequestRoutes();
        this.snapshot = new snapshot_1.SnapshotRoutes();
        this.withdrawals = new withdrawals_1.WithdrawalRoutes();
        this.deviceTokens = new device_tokens_1.DeviceTokensRoutes();
        this.services = new services_1.ServiceRoutes();
        this.referrals = new referrals_1.ReferralsRoutes();
        this.messages = new messages_1.MessagesRoutes();
        this.publicRoutes = new public_1.PublicRoutes();
        this.kyc = new kyc_1.KycRoutes();
        this.airtime = new airtime_1.AirtimeRoutes();
        this.dataBundles = new data_bundles_1.DataBundleRoutes();
        this.paystack = new paystack_1.PaystackRoutes();
        this.billers = new billers_1.BillersRoutes();
        this.limits = new limits_1.LimitsRoutes();
        this.orders = new orders_1.OrderRoutes();
        this.assetTrades = new asset_trades_1.AssetTradesRoutes();
        this.ipqs = new ipqs_fingerprint_1.IpqsFingerprintRoutes();
        this.stocks = new stocks_1.StocksRoutes();
        this.plaid = new plaid_1.PlaidRoutes();
        this.crypto = new crypto_1.CryptoRoutes();
        this.cards = new cards_1.IssuedCardRoutes();
        this.userAccountAuthorizations = new user_account_authorizations_1.UserAccountAuthorizationsRoutes();
    }
}
exports.CoreRoutes = CoreRoutes;
//# sourceMappingURL=index.js.map